export const CHANGE_INPUT_VALUE = `CHANGE_INPUT_VALUE`;

export const INIT_REQUEST = `INIT_REQUEST`;
export const INIT_SUCCESS = `INIT_SUCCESS`;
export const INIT_FAILURE = `INIT_FAILURE`;

export const SEARCH_REQUEST = `SEARCH_REQUEST`;
export const SEARCH_SUCCESS = `SEARCH_SUCCESS`;
export const SEARCH_FAILURE = `SEARCH_FAILURE`;

export const SELECT_CRITERIA_ITEM = `SELECT_CRITERIA_ITEM`;
export const REMOVE_CRITERIA_ITEM = `REMOVE_CRITERIA_ITEM`;

export const NAVIGATE_TO_DETAILS = `NAVIGATE_TO_DETAILS`;

export const GET_CODERS_REQUEST = `GET_CODERS_REQUEST`;
export const GET_CODERS_SUCCESS = `GET_CODERS_SUCCESS`;
export const GET_CODERS_FAILURE = `GET_CODERS_FAILURE`;
